/* AR Showroom — cart and wishlist. Uses helpers from ar-core.js (window.ARX). */
(() => {
  'use strict';
  const X = window.ARX;
  if (!X) return;
  const { $, $$, debounce, parse, store, url, toast, openDialog, reduceMotion, S, AR } = X;
  /* ---------------- Cart ---------------- */
  const drawerSection = () => $('#cart-drawer .cart-drawer-inner') || $('#shopify-section-cart-drawer');
  function setCount(n) {
    $$('[data-cart-count]').forEach((el) => { el.dataset.count = n; el.textContent = n > 0 ? n : ''; });
    $$('[data-cart-link]').forEach((a) => a.setAttribute('aria-label', `Cart, ${n} ${n === 1 ? 'item' : 'items'}`));
  }
  function applySections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      const doc = parse(sections['cart-drawer']);
      const src = doc.getElementById('shopify-section-cart-drawer');
      const target = drawerSection();
      if (src && target) target.innerHTML = src.innerHTML;
      const body = $('[data-cart-body]', target || document);
      if (body) setCount(parseInt(body.dataset.count || '0', 10));
    }
    const mainCart = $('[data-main-cart]');
    if (mainCart) {
      const key = mainCart.dataset.sectionId;
      if (sections[key]) {
        const doc = parse(sections[key]);
        const src = $('[data-main-cart]', doc);
        if (src) mainCart.innerHTML = src.innerHTML;
      }
    }
  }
  function sectionIds() {
    const ids = ['cart-drawer'];
    const mainCart = $('[data-main-cart]');
    if (mainCart) ids.push(mainCart.dataset.sectionId);
    return ids;
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-atc-form]');
    if (!form) return;
    e.preventDefault();
    const btn = e.submitter && e.submitter.matches('[data-atc]') ? e.submitter : $('[data-atc]', form);
    const errBox = $('[data-form-error]', form);
    if (errBox) { errBox.hidden = true; errBox.textContent = ''; }
    if (btn) btn.classList.add('is-loading');
    const fd = new FormData(form);
    fd.append('sections', sectionIds().join(','));
    fd.append('sections_url', window.location.pathname);
    try {
      const res = await fetch(`${AR.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
      const data = await res.json();
      if (!res.ok || data.status) {
        const msg = data.description || data.message || S.addError;
        if (errBox) { errBox.innerHTML = ''; const n = document.createElement('p'); n.className = 'notice notice--error'; n.textContent = msg; errBox.appendChild(n); errBox.hidden = false; }
        toast(msg, { error: true });
        return;
      }
      applySections(data.sections);
      if (AR.cartType === 'page') { window.location.href = AR.routes.cart; return; }
      if (!openDialog('cart-drawer', btn)) toast(S.added, { action: { label: S.viewCart, run: () => { window.location.href = AR.routes.cart; } } });
    } catch (err) {
      toast(S.offline, { error: true });
    } finally {
      if (btn) btn.classList.remove('is-loading');
    }
  });

  let statusEl = null;
  function announce(msg) {
    if (!statusEl) { statusEl = document.createElement('p'); statusEl.className = 'vh'; statusEl.setAttribute('role', 'status'); document.body.appendChild(statusEl); }
    statusEl.textContent = '';
    setTimeout(() => { statusEl.textContent = msg; }, 60);
  }
  /* After a re-render, put keyboard focus back on the same control, or on the nearest sensible one. */
  function restoreFocus(root, key, index, ctrl) {
    if (!root) return;
    const lines = $$('[data-line]', root);
    const same = lines.find((l) => l.dataset.key === key);
    let target = null;
    if (same && ctrl) target = $(ctrl, same);
    if (!target && lines.length) {
      const near = lines[Math.min(index - 1, lines.length - 1)];
      target = $('.line__title', near);
    }
    if (!target) target = $('.cart-empty .btn, .empty .btn', root) || $('[data-close]', root);
    if (target) target.focus({ preventScroll: true });
  }
  async function changeLine(lineEl, qty) {
    const line = parseInt(lineEl.dataset.line, 10);
    const root = lineEl.closest('#cart-drawer, [data-main-cart]');
    const key = lineEl.dataset.key;
    const name = ($('.line__title', lineEl) || {}).textContent || 'item';
    const active = document.activeElement;
    let ctrl = null;
    if (active && lineEl.contains(active)) {
      ctrl = ['[data-line-step="1"]', '[data-line-step="-1"]', '[data-line-qty]', '[data-line-remove]', '.line__title'].find((s) => active.matches(s)) || null;
    }
    lineEl.classList.add('is-updating');
    try {
      const res = await fetch(`${AR.routes.cartChange}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity: qty, sections: sectionIds(), sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) {
        lineEl.classList.remove('is-updating');
        const err = $('[data-line-error]', lineEl);
        if (err) { err.textContent = data.description || data.message || S.addError; err.hidden = false; }
        const input = $('[data-line-qty]', lineEl); if (input) input.value = input.defaultValue;
        return;
      }
      applySections(data.sections);
      if (typeof data.item_count === 'number') setCount(data.item_count);
      const lost = !document.activeElement || document.activeElement === document.body || !document.activeElement.isConnected;
      if (ctrl || lost) restoreFocus(root, key, line, ctrl);
      announce(qty === 0 ? `Removed ${name.trim()} from your cart.` : `Quantity of ${name.trim()} is now ${qty}.`);
    } catch (e) {
      lineEl.classList.remove('is-updating');
      toast(S.offline, { error: true });
    }
  }
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-line-step]');
    const rm = e.target.closest('[data-line-remove]');
    if (!step && !rm) return;
    const lineEl = e.target.closest('[data-line]');
    if (!lineEl) return;
    const input = $('[data-line-qty]', lineEl);
    if (rm) { changeLine(lineEl, 0); return; }
    const next = Math.max(0, parseInt(input.value || '0', 10) + parseInt(step.dataset.lineStep, 10));
    const max = input.max ? parseInt(input.max, 10) : Infinity;
    if (next > max) { const err = $('[data-line-error]', lineEl); if (err) { err.textContent = `Only ${max} available.`; err.hidden = false; } return; }
    input.value = next;
    changeLine(lineEl, next);
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-qty]');
    if (!input) return;
    const lineEl = input.closest('[data-line]');
    const v = Math.max(0, parseInt(input.value || '0', 10));
    changeLine(lineEl, v);
  });
  const noteEl = $('[data-cart-note]');
  if (noteEl) {
    const save = debounce(() => fetch(`${AR.routes.cartUpdate}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: noteEl.value }) }), 500);
    noteEl.addEventListener('input', save);
  }

  /* ---------------- Wishlist ---------------- */
  const WKEY = 'ar:wish';
  const wishList = () => store.get(WKEY, []);
  function syncWish() {
    if (!AR.wishOn) return;
    const list = wishList();
    $$('[data-wish]').forEach((b) => {
      const on = list.includes(b.dataset.wish);
      b.setAttribute('aria-pressed', String(on));
      const lab = $('[data-wish-label]', b); if (lab) lab.textContent = on ? 'Saved' : 'Save';
    });
    $$('[data-wish-count]').forEach((c) => { c.textContent = list.length ? list.length : ''; c.dataset.count = list.length; });
  }
  function toggleWish(h) {
    let list = wishList();
    const on = list.includes(h);
    list = on ? list.filter((x) => x !== h) : [h, ...list].slice(0, 50);
    store.set(WKEY, list);
    syncWish();
    toast(on ? S.wishRemoved : S.wishAdded, on ? {} : { action: { label: 'View', run: () => openDialog('wish-drawer') } });
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-wish]');
    if (b) { e.preventDefault(); toggleWish(b.dataset.wish); return; }
    const r = e.target.closest('[data-wish-remove]');
    if (r) {
      store.set(WKEY, wishList().filter((x) => x !== r.dataset.wishRemove));
      const row = r.closest('[data-mini]');
      const next = row && (row.nextElementSibling || row.previousElementSibling);
      if (row) row.remove();
      syncWish();
      const box = $('[data-wish-list]'); if (box && !box.children.length) $('[data-wish-empty]').hidden = false;
      const dlg = r.closest('dialog') || $('#wish-drawer');
      const target = (next && $('[data-wish-remove], a', next)) || (dlg && ($('[data-wish-empty] .btn', dlg) || $('[data-close]', dlg)));
      if (target) target.focus({ preventScroll: true });
      announce(S.wishRemoved);
    }
  });
  const wishDrawer = $('#wish-drawer');
  if (wishDrawer) {
    wishDrawer.addEventListener('ar:open', async () => {
      const box = $('[data-wish-list]', wishDrawer);
      const empty = $('[data-wish-empty]', wishDrawer);
      const list = wishList();
      empty.hidden = list.length > 0;
      box.innerHTML = list.map(() => '<div class="mini"><div class="mini__img skeleton"></div><div><div class="skeleton" style="height:14px;margin-bottom:8px"></div><div class="skeleton" style="height:14px;width:50%"></div></div></div>').join('');
      const rows = await Promise.all(list.map(async (h) => {
        try {
          const res = await fetch(url(`/products/${encodeURIComponent(h)}?section_id=ar-mini`));
          if (!res.ok) return { h, gone: res.status === 404 };
          const doc = parse(await res.text());
          const el = $('[data-mini]', doc);
          return el ? { h, html: el.outerHTML } : { h, gone: true };
        } catch (e) { return { h }; }
      }));
      const gone = rows.filter((r) => r.gone).map((r) => r.h);
      if (gone.length) { store.set(WKEY, wishList().filter((x) => !gone.includes(x))); syncWish(); }
      box.innerHTML = rows.filter((r) => r.html).map((r) => r.html).join('');
      empty.hidden = box.children.length > 0;
    });
  }

  window.addEventListener('storage', (e) => { if (e.key === WKEY) syncWish(); });
  syncWish();
  X.syncWish = syncWish;
  X.syncAll = () => { syncWish(); if (X.syncCompare) X.syncCompare(); };
})();